<template>
  <el-button :type="type" @click="open">{{ label }}
    <el-dialog :title="title" center :visible.sync="dialog">
      <el-form>
        <el-row :gutter="5" justifty="center">
          <el-col :xs="15" :sm="10" :md="8" :lg="8" :xl="8">
            <el-form-item label="Valor:">
              <el-input ref="valueData" name="value" id="value" type="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :controls="false" :min="0"
                v-model="value" v-on:keyup.native.enter="save"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.stop.prevent="dialog = false">Cancelar</el-button>
        <el-button type="success" @click.stop.prevent="save()">Confirmar</el-button>
      </span>
    </el-dialog>
  </el-button>
</template>

<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
export default {
  props: ['title', 'state', 'type', 'label'],
  data() {
    return {
      dialog: false,
      value: 0,
    }
  },
  methods: {
    open() {
      this.value = 0;
      this.dialog = true;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.valueData.$el.getElementsByTagName('input')[0].select();
        }, 200)
      })
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.transaction({
        value: vm.value,
        state: vm.state,
      }).then((response) => {
        this.$message({ type: "success", duration: 5000, message: 'Valor atribuido ao caixa com sucesso!' });
        var downloadLink = document.createElement("a");
        downloadLink.href = response.data;
        downloadLink.download = `caixa.${vm.state}.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        vm.$emit('conference', vm.value);
        this.dialog = false;
      }).catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    }
  }
}
</script>